// Allow form behavior changes to use custom selection
const Twig = require('twig');
import { apply_form_behavior } from './products-review.js';
window.apply_form_behavior = apply_form_behavior;
import './pager.js';
// @TODO: Consider to move this to global
import './form.js';
import { config } from './api.config.js';
(function ($, Drupal, window) {
  async function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  // Get the script element with id "my-custom-html"
  window.r_apply_json = async (element, templateId, target, url, route_name, callback = () => {}) => {
    // @TODO Cancel previous ajaxing
    const extra_id = $(`#${element}`).attr('r-apply-json-id') || false;
    const loading_class = extra_id
      ? `${extra_id}-r-applying-json ${element}-r-applying-json r-applying-json`
      : `${element}-r-applying-json r-applying-json`;
    const loaded_class = extra_id
      ? `${extra_id}-r-applied-json ${element}-r-applied-json r-applied-json`
      : `${element}-r-applied-json r-applied-json`;
    $('body').addClass(loading_class);
    var customHtmlScript = document.getElementById(templateId);
    let $ajaxLoading = $('nothing');
    // Check if $(target) exists
    if ($(target).length === 0) {
      $ajaxLoading = $(customHtmlScript).next('.ajax-loading');
      if ($ajaxLoading.length === 0) {
        // Create an ajax-loading div after customHtmlScript
        $(customHtmlScript).after('<div class="ajax-loading"></div>');
        $ajaxLoading = $(customHtmlScript).next('.ajax-loading');
      }
    } else {
      // Add ajax-loading class to the target
      $(target).addClass('ajax-loading');
      $ajaxLoading = $(target).addClass('own-loading');
    }

    // Trigger ajax-loading event on the document
    $(document).trigger('r-ajax-loading');

    // Get the raw content inside the script tag
    var rawContent = customHtmlScript.innerHTML;

    // Fetch JSON data from the URL
    var username = config.a;
    var password = config.b;

    // Encode the username and password to Base64
    var base64Credentials = btoa(username + ':' + password);

    // We should await
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: 'Basic ' + base64Credentials
        }
      });
      const data = await response.json();
      $ajaxLoading.removeClass('ajax-loading').not('.own-loading').remove();
      var template = Twig.twig({
        data: rawContent
      });

      data.pager = r_build_pager(element, route_name, data.total, data.total_pages, data.current, target, templateId);
      data.route_name = route_name;

      rawContent = template.render(data);

      // Write out the updated raw content to my-custom-html position
      $(target).remove();
      customHtmlScript.insertAdjacentHTML('afterend', rawContent);
      Drupal.attachBehaviors();
      callback();
      $('body').removeClass(loading_class);
      $('body').addClass(loaded_class);
    } catch (error) {
      console.error('Retrying. Error fetching JSON:', error);
      const randomTime = Math.floor(Math.random() * 3000) + 500;
      await delay(randomTime);
      await r_apply_json(element, templateId, target, url, route_name, callback);
    }

    $(document).trigger('r-ajax-loaded');
  };
})(jQuery, Drupal, window);
